import React, { useState } from 'react'
import { userImageUrls } from '../../constants'
import formatAmount from '../../utilities/formatAmount'
import styles from './SettleGroups.module.scss'

const Avatar = ({ url, size }) => (
  <img className={styles.avatar} style={size ? { width: size, height: size } : null} src={url || userImageUrls[0]} alt="" />
)

// Settle plan grouped by 收款者 (creditor), collapsible.
// groups: [{ payer:{id,name,img}, total, debts:[{ower:{id,name,img}, amount}] }]
// onMarkPaid({ from: ower, to: payer, amount }) — ower (還款者) pays payer (收款者).
const SettleGroups = ({ groups, symbol = '$', exponent = 0, onMarkPaid, defaultOpen = false }) => {
  const [open, setOpen] = useState({})
  const isOpen = (i) => (i in open ? open[i] : defaultOpen)
  const toggle = (i) => setOpen((o) => ({ ...o, [i]: !isOpen(i) }))

  return (
    <div className={styles.wrap}>
      {groups.map((g, i) => (
        <div className={styles.group} key={g.payer.id || i}>
          <button type="button" className={styles.groupHead} onClick={() => toggle(i)}>
            <Avatar url={g.payer.img} />
            <div className={styles.groupInfo}>
              <div className={styles.groupName}>{g.payer.name}</div>
              <div className={styles.groupSub}>{g.debts.length} 人要付給他</div>
            </div>
            <div className={styles.groupAmtBox}>
              <div className={styles.groupAmtLabel}>應收</div>
              <div className={styles.groupAmt}>{formatAmount(g.total, exponent, symbol)}</div>
            </div>
            <span className={styles.caret}>{isOpen(i) ? '⌃' : '⌄'}</span>
          </button>

          {isOpen(i) && (
            <div className={styles.groupBody}>
              {g.debts.map((d, j) => (
                <div className={styles.debtRow} key={j}>
                  <Avatar url={d.ower.img} size={24} />
                  <span className={styles.debtName}>{d.ower.name}</span>
                  <span className={styles.debtAmt}>{formatAmount(d.amount, exponent, symbol)}</span>
                  {onMarkPaid && (
                    <button
                      type="button"
                      className={styles.payBtn}
                      onClick={() => onMarkPaid({ from: d.ower, to: g.payer, amount: d.amount })}
                    >還款</button>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  )
}

export default SettleGroups
